import { useSearchParams } from 'next/navigation';
import { useEffect, useMemo, useState } from 'react';

import type { ActivityCollectionParams } from '@/services/collection';
import { getActivityCollectionById } from '@/services/collection';

import type { ActivityDataTable } from './helpers';
import { convertToDataActivityTable } from './helpers';

export const PAGE_SIZE = 8;

const useActivity = (collectionId: number | string | null) => {
  const [list, setList] = useState<ActivityDataTable[]>([]);
  const [totalPage, setTotalPage] = useState(0);
  const [loading, setLoading] = useState(false);

  const searchParam = useSearchParams();
  const page = searchParam.get('page') ?? 1;
  // const createdAt = searchParam.get('createdAt') ?? 'DESC';
  const filterEvent = searchParam.get('event');

  const inputParams: ActivityCollectionParams = useMemo(
    () => ({
      offset: (Number(page) - 1) * PAGE_SIZE,
      size: PAGE_SIZE,
      // sortDate: createdAt,
      filterEvent,
    }),
    [page, filterEvent],
  );

  const getListActivity = async () => {
    if (!collectionId) return;
    setLoading(true);

    const res = await getActivityCollectionById(collectionId, inputParams);

    setTotalPage(res?.data?.count || 0);
    const dataList = convertToDataActivityTable(res?.data?.items || []);
    setList(dataList);
    setLoading(false);
  };

  useEffect(() => {
    getListActivity();
  }, [inputParams]);

  return {
    list,
    totalPage,
    loading,
  };
};

export default useActivity;
